export enum SubsectionRendering {
  Inline = 'inline',
  Drawer = 'drawer',
  Hidden = 'hidden',
}
